const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgIconTypeRef2D(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "6.7314mm",
    height: "6.7314mm",
    viewBox: "0 0 6.7314 6.7314",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    transform: "translate(-36.146 -81.165)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1.1 0 0 1.1 -3.7403 -8.4531)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1.331 0 0 1.331 -13.383 -27.108)",
    stroke: "#000000",
    strokeLinecap: "round",
    strokeWidth: 0.12003
  }, /*#__PURE__*/React.createElement("path", {
    d: "m39.248 82.442h.28334c.21389 0 .33163.20971.33163.37821v1.0556h.96069",
    style: {
      fill: "none",
      strokeLinejoin: "round",
      strokeWidth: 0.1366
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m40.402 83.398.42133.47772-.42133.47772",
    style: {
      fill: "none",
      strokeWidth: 0.1366
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m39.248 85.31h.28334c.21389 0 .33163-.20971.33163-.37821v-1.0556h.96069",
    style: {
      fill: "none",
      strokeLinejoin: "round",
      strokeWidth: 0.1366
    }
  })), /*#__PURE__*/React.createElement("text", {
    x: 36.335449,
    y: 83.717476,
    style: {
      fill: "#000000",
      fontFamily: "Univers",
      fontSize: "2.9482px",
      letterSpacing: 0,
      lineHeight: 0,
      strokeWidth: ".023585px",
      wordSpacing: 0
    },
    xmlSpace: "preserve"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 36.335449,
    y: 83.717476,
    style: {
      fill: "#000000",
      fontFamily: "Figtree",
      fontWeight: 500,
      strokeWidth: ".023585px"
    }
  }, "A")), /*#__PURE__*/React.createElement("text", {
    x: 40.950912,
    y: 86.049683,
    style: {
      fill: "#000000",
      fontFamily: "Univers",
      fontSize: "4.1761px",
      letterSpacing: 0,
      lineHeight: 0,
      strokeWidth: ".033408px",
      wordSpacing: 0
    },
    xmlSpace: "preserve"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 40.950912,
    y: 86.049683,
    style: {
      fill: "#000000",
      fontFamily: "Figtree",
      strokeWidth: ".033408px"
    }
  }, "1")), /*#__PURE__*/React.createElement("text", {
    x: 36.359005,
    y: 87.518799,
    style: {
      fill: "#000000",
      fontFamily: "Univers",
      fontSize: "2.9482px",
      letterSpacing: 0,
      lineHeight: 0,
      strokeWidth: ".023585px",
      wordSpacing: 0
    },
    xmlSpace: "preserve"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 36.359005,
    y: 87.518799,
    style: {
      fill: "#000000",
      fontFamily: "Figtree",
      fontWeight: 500,
      strokeWidth: ".023585px"
    }
  }, "B")))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconTypeRef2D);
export default __webpack_public_path__ + "static/media/icon_type_ref_2d.df07557d62d5da75ded4ea1cec5fd8e1.svg";
export { ForwardRef as ReactComponent };